import React, { useState } from "react";
import { Form, Button, Card, Row, Col } from "react-bootstrap";

export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    const response = await fetch("https://prdp-api.suport-949.workers.dev/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    if (response.ok) {
      setStatus("success");
      setForm({ name: "", email: "", subject: "", message: "" });
    } else {
      setStatus("error");
    }
    setLoading(false);
  };

  const isFormIncomplete = !form.name || !form.email || !form.subject || !form.message;

  return (
    <Row className="justify-content-center align-items-center min-vh-100">
      <Col xs={12} md={6} lg={5}>
        <Card className="neumorph-card p-4">
          <Card.Body>
            <h3 className="mb-3 text-primary-dark bold-title">Contactează-ne</h3>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Nume</Form.Label>
                <Form.Control
                  className="neumorph-input"
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  placeholder="Numele tău"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  className="neumorph-input"
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="Adresa ta de email"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Titlu</Form.Label>
                <Form.Control
                  className="neumorph-input"
                  type="text"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  placeholder="Subiectul mesajului"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Mesaj</Form.Label>
                <Form.Control
                  className="neumorph-input"
                  as="textarea"
                  rows={5}
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  required
                  placeholder="Scrie mesajul tău aici..."
                />
              </Form.Group>
              <Button
                className="w-100 btn custom-neu-button btn-lg"
                type="submit"
                disabled={loading || isFormIncomplete}
              >
                {loading ? "Se trimite..." : "Trimite mesajul"}
              </Button>
              {status === "success" && (
                <div className="mt-3 text-success">Mesajul a fost trimis cu succes!</div>
              )}
              {status === "error" && (
                <div className="mt-3 text-danger">A apărut o eroare. Încearcă din nou.</div>
              )}
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
